import { render, staticRenderFns } from "./vsTh.vue?vue&type=template&id=58268fd2&"
import script from "./vsTh.vue?vue&type=script&lang=js&"
export * from "./vsTh.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "vsTh.vue"
export default component.exports